/**
 * Middle layer to abstract the SDK calls while they are being finalized
 * Also makes any updates/edits to the SDK easier to find.
 */
let APIManager = function (sdk) {
  if (APIManager.prototype._singletonInstance) {
    return APIManager.prototype._singletonInstance;
  }

  APIManager.prototype._singletonInstance = this;

  // the first time the APIManager singleton is initialize, it needs to be given a reference to the SDK
  // this logic could probably be improved
  if (sdk === undefined) {
    console.warn('SDK initialized without a reference to the SDK');
    sdk.debug('SDK initialized without a reference to the SDK');
  }
  this.sdk = sdk;
  // console.log('APIManager.init', sdk);
};

APIManager.prototype.getGameState = function () {
  // console.log('APIManager.getGameState');
  this.sdk.debug('APIManager.getGameState');
  return this.sdk.getGameState();
};

APIManager.prototype.setGameState = function (state) {
  try {
    // console.log('APIManager.setGameState', state);
    this.sdk.debug('APIManager.setGameState');
    this.sdk.setGameState(state).catch(error => {
      console.warn('APIManager.setGameState: Error saving game state =>', error);
      this.sdk.debug('APIManager.setGameState: Error saving game state =>', error);
    }).then(() => {
      console.log('APIManager.setGameState: SDK stored game state', state);
      this.sdk.debug('APIManager.setGameState: SDK stored game state', state);
    });
  } catch (e) {
    // console.log('APIManager.setGameState: error setting game state in sdk: ' + e);
    this.sdk.debug('APIManager.setGameState: error setting game state in sdk: ' + e);
  }
};

APIManager.prototype.setHighScore = function (score) {
  try {
    // console.log('APIManager.setHighScore ' + score);
    this.sdk.debug('APIManager.setHighScore ' + score);
    this.sdk.setHighScore(score).catch(error => {
      console.warn('APIManager.setHighScore: Error saving high score =>', error);
      this.sdk.debug('APIManager.setHighScore: Error saving high score =>', error);
    }).then(() => {
      // console.log('APIManager.setHighScore: SDK stored high score', score);
      this.sdk.debug('APIManager.setHighScore: SDK stored high score', score);
    });
  } catch (e) {
    console.warn('APIManager.setHighScore: Error setting high score in sdk:', e);
    this.sdk.debug('APIManager.setHighScore: Error setting high score in sdk:', e);
  }
};

APIManager.prototype.getHighScore = function () {
  // console.log('APIManager.getHighScore');
  this.sdk.debug('APIManager.getHighScore');
  return this.sdk.getHighScore();
};

APIManager.prototype.showAd = function () {
  // console.log('APIManager.showAd');
  this.sdk.debug('APIManager.showAd');
  // return new Promise((resolve) => {
  //   resolve();
  // });
  return this.sdk.showAd();
};

APIManager.prototype.trackGameStart = function () {
  try {
    // console.log('APIManager.trackGameStart');
    this.sdk.debug('APIManager.trackGameStart');
    this.sdk.analytics.trackPlay('play');
  } catch (e) {
    console.warn('APIManager.trackGameStart error tracking game start in sdk:', e);
    this.sdk.debug('APIManager.trackGameStart error tracking game start in sdk:', e);
  }
};

APIManager.prototype.trackGameTitle = function () {
  try {
    // console.log('APIManager.trackGameTitle');
    this.sdk.debug('APIManager.trackGameTitle');
    this.sdk.analytics.trackPlay('title');
  } catch (e) {
    console.warn('APIManager.trackGameTitle error tracking game title in sdk:', e);
    this.sdk.debug('APIManager.trackGameTitle error tracking game title in sdk:', e);
  }
};

APIManager.prototype.trackGamePause = function () {
  try {
    // console.log('APIManager.trackGamePause');
    this.sdk.debug('APIManager.trackGamePause');
    this.sdk.analytics.trackPlay('pause');
  } catch (e) {
    console.warn('APIManager.trackGamePause error tracking game pause in sdk:', e);
    this.sdk.debug('APIManager.trackGamePause error tracking game pause in sdk:', e);
  }
};

APIManager.prototype.trackGameShop = function () {
  try {
    // console.log('APIManager.trackGameShop');
    this.sdk.debug('APIManager.trackGameShop');
    this.sdk.analytics.trackPlay('shop');
  } catch (e) {
    console.warn('APIManager.trackGameShop error tracking game shop in sdk:', e);
    this.sdk.debug('APIManager.trackGameShop error tracking game shop in sdk:', e);
  }
};

APIManager.prototype.getAchievement = function (id) {
  // console.log('APIManager.getAchievement', id);
  this.sdk.debug('APIManager.getAchievement', id);
  let stored = null;
  try {
    stored = this.sdk.achievements.find(achievement => achievement.id === id);
  } catch (e) {
    console.warn('APIManager.getAchievement', e);
    this.sdk.debug('APIManager.getAchievement', e);
  }
  return stored;
};

APIManager.prototype.unlockAchievement = function (id) {
  // console.log('APIManager.unlockAchievement', id);
  this.sdk.debug('APIManager.unlockAchievement', id);
  try {
    this.sdk.unlockAchievement(id);
  } catch (e) {
    console.warn('APIManager.unlockAchievement', e);
    this.sdk.debug('APIManager.unlockAchievement', e);
  }
};

APIManager.prototype.getAchievementProgress = function (id) {
  // console.log('APIManager.getAchievementProgress', id);
  this.sdk.debug('APIManager.getAchievementProgress', id);
  return this.sdk.getAchievementProgress(id);
};

APIManager.prototype.setAchievementProgress = function (id, progress) {
  // console.log('APIManager.setAchievementProgress', id, progress);
  this.sdk.debug('APIManager.setAchievementProgress', id, progress);
  try {
    this.sdk.setAchievementProgress(id, progress);
  } catch (e) {
    console.warn('APIManager.setAchievementProgress', e);
    this.sdk.debug('APIManager.setAchievementProgress', e);
  }
};

module.exports = APIManager;
